export const FormatDateTime = (dateString, timeZone) => {
  if (!dateString) return "";

  const date = new Date(dateString);
  //We check the timezone
  if (timeZone === undefined) {
    const pad = (n) => n.toString().padStart(2, '0');

    const day = pad(date.getUTCDate());
    const month = pad(date.getUTCMonth() + 1);
    const year = date.getUTCFullYear();

    let hours = date.getUTCHours();
    const minutes = pad(date.getUTCMinutes());

    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // Convert to 12-hour format
    hours = pad(hours);

    return `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`;
  } else {
    try {
      return date.toLocaleString("es-PA", {
        dateStyle: "short",
        timeStyle: "short",
        timeZone,
      });
    } catch (e) {
      return date.toLocaleString("es-PA", {
        dateStyle: "short",
        timeStyle: "short",
        timeZone: "America/Panama",
      });
    }
  }

};
